module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-800.woff2?ab3e500e7375695d702cff19513e4470";